<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiHospitalBoxOutline }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Availment Procedure
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <!-- END APP BAR -->

        <v-container>
            <div class="procedure">
                <h2>In-patient Services</h2>
                <v-divider />
                <div class="proc-img">
                    <img src="../../assets/In-Patient Care.png" alt="">
                </div>
            </div>
            <div class="procedure">
                <h2>Out-patient Services</h2>
                <v-divider />
                <div class="proc-img">
                    <img src="../../assets/Out-Patient Care.png" alt="">
                </div>
            </div>
            <div class="procedure">
                <h2>Emergency Care Services</h2>
                <v-divider />
                <div class="proc-img">
                    <img src="../../assets/Emergency Care.png" alt="">
                </div>
                <div class="proc-img">
                    <img src="../../assets/Emergency Care 2.png" alt="">
                </div>
            </div>
            <div class="procedure">
                <h2>Dental Care Services</h2>
                <v-divider />
                <div class="proc-img">
                    <img src="../../assets/Dental Care.png" alt="">
                </div>
            </div>
        </v-container>
    </section>
</template>

<script>
import { mdiHospitalBoxOutline } from '@mdi/js'

export default {
    data: () => ({
        mdiHospitalBoxOutline
    })
}
</script>

<style scoped>
section {
  background-image: url("../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}

.procedure {
  width: 80%;
  margin: auto;
}
.procedure h2 {
  color: #1b5e20;
  font-size: 1.8em;
}

.proc-img {
  width: 60%;
  padding: 2em 0;
  margin: auto;
}

.nav h2 {
    font-size: 25px;
}
.proc-img img {
  width: 100%;
}

/* @media (max-width: 960px) {
  .procedure {
    width: 90%;
  }
  .proc-img {
    width: 100%;
  }
} */
@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}
@media (max-width: 1260px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    padding-top: 10px;
    font-size: 30px;
  }
  .procedure {
    width: 90%;
  }
  .proc-img {
    width: 100%;
  }
}
</style>
